import $ from 'jquery'
import workspaceAPI from '@/api/workspace'
import store from '@/store/index'
import { statusBadges } from '@/config/content/statuses'

export default {
  data() {
    return {
      height: 0,
      width: 0
    }
  },
  methods: {
    $_contentMixin_addFN(file) {
      store.commit('content/addFileName', file)
      // store.modules.content.mutations.addFileName(store.modules.content.state, file)
    },
    $_contentMixin_getBadge(status) {
      return statusBadges[status]
    },
    $_contentMixin_editCaptions(text) {
      const parser = new DOMParser()
      const parsed = parser.parseFromString(text, 'text/html').getElementsByTagName('body')[0]
      if (parsed) {
        const parsedArray = Array.from(parsed.getElementsByTagName('figure'))
        if (parsedArray.length > 0) {
          parsedArray.forEach((p, idx) => {
            const img = p.getElementsByTagName('img')[0]
            if (img) {
              const caption = p.getElementsByTagName('figcaption')[0]
              const href = document.createElement('a')
              href.setAttribute('href', img.getAttribute('src'))
              href.setAttribute('target', '_blank')
              href.setAttribute('rel', 'noopener noreferrer')
              href.appendChild(img)
              img.id = `img-${idx}`
              img.setAttribute('v-b-tooltip.hover', '')
              img.setAttribute('title', 'Открыть в новой вкладке')
              img.className = 'courseImg'
              img.setAttribute('style', 'border: 3px solid #f9fafc;')
              p.appendChild(href)
              if (caption) {
                const newCaption = document.createElement('figcaption')
                newCaption.innerHTML = caption.innerHTML
                p.removeChild(caption)
                p.appendChild(newCaption)
              }
            }
          })
          $('.courseImg').mouseenter(function jq() {
            $(this).css('border', '3px solid #0078c1')
          }).mouseleave(function jq() {
            $(this).css('border', '3px solid #f9fafc')
          })
          return parsed.innerHTML
        }
      }

      return text
    },
    $_contentMixin_uploadImages(text) {
      function urltoFile(b64Data, contentType = '', sliceSize = 512) {
        const byteCharacters = atob(b64Data)
        const byteArrays = []

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          const slice = byteCharacters.slice(offset, offset + sliceSize)

          const byteNumbers = new Array(slice.length)
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i)
          }

          const byteArray = new Uint8Array(byteNumbers)
          byteArrays.push(byteArray)
        }

        return new File(byteArrays, store
          .getters['content/getFileNames'][b64Data.substring(0, 100)],
        { type: contentType })
      }

      const parser = new DOMParser()
      const parsed = parser.parseFromString(text, 'text/html')
        .getElementsByTagName('body')[0]
      if (parsed) {
        const parsedArray = Array.from(parsed.getElementsByTagName('figure'))
        if (parsedArray.length > 0) {
          const promises = []
          parsedArray.forEach((p) => {
            const img = p.getElementsByTagName('img')[0]
            if (img && img.getAttribute('src').includes('data:image')) {
              promises.push(
                new Promise((resolve) => {
                  workspaceAPI.uploadFiles([
                    urltoFile(img.getAttribute('src').split(',')[1],
                      'image/png')
                  ]).then((response) => {
                    img.setAttribute('src',
                      `/api/files/${response.data[0].physicalName}`)
                    resolve()
                  })
                }),
              )
            }
          })
          if (promises.length > 0) {
            return new Promise((resolve) => {
              Promise.all(promises).then(() => {
                resolve(parsed.innerHTML)
              })
            })
          }
          return Promise.resolve(text)
        }
        return Promise.resolve(text)
      }
      return Promise.resolve(text)
    }
  }
}
